import React, { useState } from 'react';
import ButtonsGeneric from '../../../../../../../../components/NovoSistema/ButtonsGeneric';
import { ContainerSection } from '../../../../../../../../components/NovoSistema/ContainerSection';
import { WrapperInputsNewSystem } from '../../../../../../../../components/NovoSistema/WrapperInputsNewSystem';
import ButtonOptions from '../../../../../../../../components/NovoSistema/ButtonOptions';
import HeaderButtons from '../../../../../../../../components/NovoSistema/HeaderButtons';
import SelectAndOptions from '../../../../../../../../components/NovoSistema/SelectAndOptions';
import InputDate from '../../../../../../../../components/NovoSistema/InputDate';
import DoubleInput from '../../../../../../../../components/NovoSistema/DoubleInput';
import InputText from '../../../../../../../../components/NovoSistema/InputText';

export default function ServicoTomadoFilter() {
  const [option, setOption] = useState('Filtro');
  return (
    <div>
      <HeaderButtons>
        <ButtonOptions
          buttonName="Filtro"
          border="#DFB007"
          active={option === 'Filtro' ? true : false}
          yourFunction={() => setOption('Filtro')}
        />
      </HeaderButtons>
      {option === 'Filtro' && (
        <ContainerSection>
          <WrapperInputsNewSystem>
            <InputDate title="Entrada Inicial" id="EntradaInicial" widthPercentage="20%" />
            <InputDate title="Entrada Final" id="EntradaFinal" widthPercentage="20%" />
            <DoubleInput title="Parceiro de Negócios" id="ParceiroDeNegocios" widthPercentage="40%" />
          </WrapperInputsNewSystem>
          <WrapperInputsNewSystem>
            <SelectAndOptions
              title="Documento Fiscal"
              id="DocumentoFiscal"
              optionsArray={[
                '',
                '100 | NFS | Nota Fiscal Serviço',
                '101 | NFFS | Nota Fiscal Fatura de Serviços',
                '106 | RS | Recibo de Serviço',
                '104 | M01F | Nota Fiscal Fatura (Modelo 1)',
              ]}
              widthPercentage="40%"
            />
            <DoubleInput title="Serviço" id="Servico" widthPercentage="40%" />
          </WrapperInputsNewSystem>
          <WrapperInputsNewSystem>
            <SelectAndOptions
              title="Tipo de Relatório"
              id="TipoDeRelatorio"
              optionsArray={['Analítico', 'Sintético']}
              widthPercentage="30%"
            />
            <InputText title="Nº Docto" id="NDocto" widthPercentage="30%" />
            <SelectAndOptions
              title="Ordenar Por"
              id="OrdenarPor"
              optionsArray={['Data Entrada', 'Data Emissão', 'Nº Docto', 'Parceiro de Negócio']}
              widthPercentage="30%"
            />
          </WrapperInputsNewSystem>
          <ButtonsGeneric>
            <button className="normal">Limpar</button>
          </ButtonsGeneric>
        </ContainerSection>
      )}
    </div>
  );
}
